import { QueryClient } from '@tanstack/react-query';
import { assignIdLogRocket } from 'src/analytics/logRocket';
import { getAllBasicCompaniesQueryOptions } from 'src/queries/Company';
import { EMPLOYEE_QUERY_KEY, ENTITY_KEY } from 'src/queries/queryKeys';
import { Employee, BasicCompany } from 'src/types';
import { hideIntercomIfDisabled, updateIntercomUser } from 'src/util/intercom';

export const initAuthUser = async (employeeKey: string, queryClient: QueryClient) => {
  const employee = queryClient.getQueryData<Employee>([EMPLOYEE_QUERY_KEY, ENTITY_KEY, employeeKey]);
  if (!employee) return;

  // Identify the session straight away rather than after the companies load.
  assignIdLogRocket(employee);

  const { companyKeys } = employee;

  let employeeCompanies: BasicCompany[] | undefined = undefined;
  if (companyKeys?.length) {
    const companiesList = await queryClient.fetchQuery(getAllBasicCompaniesQueryOptions());
    const employeeCompanyKeysSet = new Set(companyKeys);
    employeeCompanies = companiesList.filter((company) => employeeCompanyKeysSet.has(company.key));
  }

  updateIntercomUser(employee, employeeCompanies);
  hideIntercomIfDisabled(employeeCompanies);
};
